import React from 'react'

import Container from '@mui/material/Container'

type Props = {
  children: any
}

const LayoutStyle: React.FC<Props> = ({ children }) => {
  return (
    <Container
      maxWidth="xl"
      disableGutters
      sx={{
        // cadrage horizontal responsive
        px: { xs: 0, sm: 2, md: 3 },
        // annuler styles par défaut potentiels du thème
        boxShadow: 'none',
        borderRadius: 0,
      }}
    >
      {children}
    </Container>
  )
}

export default LayoutStyle
